import { render, staticRenderFns } from "./ReactionsOverlay.vue?vue&type=template&id=e51b9912&lang=pug&"
import script from "./ReactionsOverlay.vue?vue&type=script&lang=js&"
export * from "./ReactionsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ReactionsOverlay.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports